import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-common';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private accessToken: string;
  private refreshToken: string;

  constructor(
    private msalService: MsalService,
    private broadcastService: MsalBroadcastService,
    private router: Router,
    private config: ConfigService,
    private http: HttpClient
  ) {}

  signIn(): Observable<AuthenticationResult> {
    return this.msalService.loginPopup().pipe(
      catchError((err: any) => {
        // If an interactive request is already in progress, wait until
        // MSAL reports no interaction in progress then retry once.
        const isInteractionInProgress =
          err &&
          (err.errorCode === 'interaction_in_progress' ||
            (err.errorMessage && err.errorMessage.indexOf('interaction_in_progress') >= 0));
        if (isInteractionInProgress) {
          return this.broadcastService.inProgress$.pipe(
            filter((status: any) => status === 'none'),
            take(1),
            switchMap(() => this.msalService.loginPopup())
          );
        }
        return throwError(err);
      })
    );
  }

  login() {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', 'Basic ' + this.getAuthorizationHeader());

    let userData = JSON.parse(sessionStorage.getItem('userInfo'));

    const body = new HttpParams()
      .set('grant_type', 'urn:ietf:params:oauth:grant-type:jwt-bearer')
      .set('assertion', userData.idToken)
      .toString();

    return this.http
      .post(this.config.getConfig('ApiBaseURL').concat('/o365/oauth2/v2/token'), body, {
        headers: headers,
      })
      .pipe(
        map((data) => {
          this.accessToken = data['access_token'];
          this.refreshToken = data['refresh_token'];
          sessionStorage.setItem(
            'currentUser',
            JSON.stringify({ accessToken: this.accessToken, refreshToken: this.refreshToken })
          );
          sessionStorage.setItem('fullTokenPayload', JSON.stringify(data));
          localStorage.setItem(
            'currentUser',
            JSON.stringify({ accessToken: this.accessToken, refreshToken: this.refreshToken })
          );
          localStorage.setItem('fullTokenPayload', JSON.stringify(data));
        })
      );
  }

  refreshAccessToken(): Observable<void> {
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    let refreshToken = currentUser.refreshToken;
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', 'Basic ' + this.getAuthorizationHeader());
    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', refreshToken)
      .toString();

    return this.http
      .post(this.config.getConfig('ApiBaseURL').concat('/o365/oauth2/v2/token'), body, {
        headers: headers,
      })
      .pipe(
        map((data) => {
          this.accessToken = data['access_token'];
          this.refreshToken = data['refresh_token'];
          sessionStorage.setItem(
            'currentUser',
            JSON.stringify({ accessToken: this.accessToken, refreshToken: this.refreshToken })
          );
          sessionStorage.setItem('fullTokenPayload', JSON.stringify(data));
          localStorage.setItem(
            'currentUser',
            JSON.stringify({ accessToken: this.accessToken, refreshToken: this.refreshToken })
          );
          localStorage.setItem('fullTokenPayload', JSON.stringify(data));
          if (currentUser) {
            currentUser.accessToken = this.accessToken;
            currentUser.refreshToken = this.refreshToken;
            sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
          }
        })
      );
  }

  private getAuthorizationHeader(): string {
    return btoa(this.config.getConfig('ClientKey') + ':' + this.config.getConfig('ClientSecret'));
  }

  getAccessToken(): string {
    return JSON.parse(sessionStorage.getItem('currentUser')).accessToken;
  }
}
